import React, { useState } from 'react';
import HousekeeperCard from './HousekeeperCard';
import StatsBar from './StatsBar';
import './HousekeeperListPage.css';

export default function HousekeeperListPage({ currentUser, userRole, canAdd, navigateTo, onLogout, housekeepers, filteredHousekeepers, searchQuery, setSearchQuery, stats, fetchHousekeepers, showGlobalHeader }) {
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 50;

  const handleCardClick = (hk) => {
    if (!currentUser) { navigateTo('login'); return; }
    const status = hk.resume_status || 'draft';
    if (status === 'draft') {
      navigateTo('edit1', { id: hk.id, mode: 'continue' });
    } else {
      navigateTo('detail', { id: hk.id });
    }
  };

  // 搜索时重置到第一页
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  // admin角色且数据超过50条时启用分页
  const enablePagination = userRole === 'admin' && filteredHousekeepers.length > pageSize;
  const totalPages = enablePagination ? Math.ceil(filteredHousekeepers.length / pageSize) : 1;

  // 当前页显示的数据
  const displayData = enablePagination
    ? filteredHousekeepers.slice((currentPage - 1) * pageSize, currentPage * pageSize)
    : filteredHousekeepers;

  return (
    <div className="list-container">
      {!showGlobalHeader && (
        <header className="page-header">
          <div className="page-title-section">
            <div className="page-icon">🏠</div>
            <div>
              <h1 className="page-title">家政管理</h1>
              <p className="page-subtitle">阿姨信息管理平台</p>
            </div>
          </div>
          <div className="header-actions">
            {currentUser ? (
              <>
                <span className="user-nickname">{currentUser.nickname}</span>
                <span className="user-role-tag">
                  {userRole === 'admin' ? '管理员' : userRole === 'sales' ? '销售' : '招生'}
                </span>
                <button className="btn-logout-sm" onClick={onLogout}>退出</button>
              </>
            ) : (
              <button className="btn-login-sm" onClick={() => navigateTo('login')}>登录</button>
            )}
          </div>
        </header>
      )}

      <div className="search-bar">
        <span className="search-icon">🔍</span>
        <input className="search-input" placeholder="搜索阿姨姓名..." value={searchQuery} onChange={handleSearchChange} />
        {searchQuery && <span className="search-count">{filteredHousekeepers.length}人</span>}
      </div>

      <StatsBar stats={stats} />

      {filteredHousekeepers.length > 0 ? (
        <div className="card-list">
          {displayData.map(hk => (
            <HousekeeperCard key={hk.id} hk={hk} onClick={handleCardClick} userRole={userRole} navigateTo={navigateTo} onDelete={fetchHousekeepers} />
          ))}
        </div>
      ) : (
        <div className="empty-state">
          <div className="empty-icon">📋</div>
          <div className="empty-title">{searchQuery ? '没有找到匹配的阿姨' : '暂无阿姨数据'}</div>
          <div className="empty-desc">{searchQuery ? '请尝试其他搜索条件' : '点击下方按钮添加阿姨'}</div>
        </div>
      )}

      {canAdd && (
        <div className="bottom-bar">
          <button className="add-btn" onClick={() => navigateTo('edit1', { mode: 'add' })}>
            <span className="add-icon">+</span>
            <span className="add-text">新增阿姨</span>
          </button>
        </div>
      )}

      {enablePagination && (
        <div className="pagination">
          <button
            className="pagination-btn"
            disabled={currentPage === 1}
            onClick={() => setCurrentPage(currentPage - 1)}
          >
            上一页
          </button>
          {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
            <button
              key={page}
              className={`pagination-btn ${currentPage === page ? 'active' : ''}`}
              onClick={() => setCurrentPage(page)}
            >
              {page}
            </button>
          ))}
          <button
            className="pagination-btn"
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage(currentPage + 1)}
          >
            下一页
          </button>
        </div>
      )}
    </div>
  );
}

